import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import intersect from '@alpinejs/intersect';
import persist from '@alpinejs/persist';

// npm install swiper
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

Alpine.plugin(collapse);
Alpine.plugin(intersect);
Alpine.plugin(persist);
Alpine.start();

const events = new Swiper(".event-carousel", {
  loop: true,
  centeredSlides: true,
  slidesPerView: 1,
  spaceBetween: 30,
  breakpoints: {
    640: {
      slidesPerView: 3,
    },
  },
  navigation: {
    //nextEl: '.swiper-button-next',
    //prevEl: '.swiper-button-prev',
    nextEl: '.swiper-custom-next',
    prevEl: '.swiper-custom-prev',
  },
});

const multiColGallery = new Swiper(".multi-column-gallery-carousel", {
  loop: true,
  centeredSlides: true,
  slidesPerView: 1,
  spaceBetween: 30,
  breakpoints: {
    640: {
      slidesPerView: 3,
    },
  },
  navigation: {
    nextEl: '.swiper-custom-next',
    prevEl: '.swiper-custom-prev',
  },
});

const offcenter = new Swiper(".offCenter-carousel", {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 30,
  breakpoints: {
    641: {
      slidesPerView: 4,
    },
  },
  navigation: {
    nextEl: '.swiper-custom-next',
    prevEl: '.swiper-custom-prev',
  },
});

const eventDetail = new Swiper(".event-detail-carousel", {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 30,
  navigation: {
    nextEl: '.swiper-custom-next',
    prevEl: '.swiper-custom-prev',
  },
});

const logos = new Swiper(".logo-carousel", {
  loop: true,
  slidesPerView: 2,
  spaceBetween: 30,
  navigation: {
    nextEl: '.swiper-custom-next',
    prevEl: '.swiper-custom-prev',
  },
});
